import React from 'react';
import { t } from '../../lib/i18n';
import { Progress } from '../ui/progress';
import { getStateColor } from '../../lib/utils';
import { Activity } from 'lucide-react';

const stateKeys = [
  { key: 'zniecierpliwienie', labelKey: 'impatience', icon: '\u26a1' },
  { key: 'zaciekawienie', labelKey: 'curiosity', icon: '\ud83d\udd0d' },
  { key: 'dystans', labelKey: 'distance', icon: '\ud83d\udee1' },
  { key: 'satysfakcja', labelKey: 'satisfaction', icon: '\u2713' },
];

export function AdamStateMeter({ state, lang = 'pl' }) {
  if (!state) return null;

  // Calculate overall "pulse" - weighted state indicator
  const tension = (state.zniecierpliwienie || 0) * 0.4 + (state.dystans || 0) * 0.3;
  const positivity = (state.zaciekawienie || 0) * 0.3 + (state.satysfakcja || 0) * 0.4;
  const pulse = Math.max(0, Math.min(1, 0.5 + positivity - tension));

  const pulseColor = pulse > 0.6 ? '#22C7A3' : pulse > 0.35 ? '#D8B07A' : '#E05252';
  const pulseLabel = pulse > 0.6
    ? (lang === 'pl' ? 'Stabilny' : 'Stable')
    : pulse > 0.35
      ? (lang === 'pl' ? 'Czujny' : 'Alert')
      : (lang === 'pl' ? 'Napi\u0119ty' : 'Tense');

  return (
    <div className="space-y-3" data-testid="insights-adam-emotion-meter">
      {/* Adam Pulse */}
      <div className="flex items-center gap-2 mb-3">
        <Activity className="w-4 h-4" style={{ color: pulseColor }} />
        <span className="text-xs font-medium" style={{ color: pulseColor }}>
          {pulseLabel}
        </span>
        <div className="flex-1 h-1 rounded-full bg-muted overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{ width: `${pulse * 100}%`, backgroundColor: pulseColor }}
          />
        </div>
      </div>

      {/* Individual states */}
      {stateKeys.map(({ key, labelKey }) => {
        const value = state[key] || 0;
        const color = getStateColor(value);
        return (
          <div key={key} className="space-y-1">
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">{t(labelKey, lang)}</span>
              <span className="text-xs font-mono font-medium" style={{ color }}>
                {Math.round(value * 100)}%
              </span>
            </div>
            <Progress
              value={value * 100}
              className="h-1.5"
              style={{ '--progress-color': color }}
            />
          </div>
        );
      })}
    </div>
  );
}
